<script setup>
import { nextTick, onMounted, ref } from 'vue'

const props = defineProps({
  modelValue: { type: String, default: '' },
  placeholder: { type: String, default: 'Поиск' },
  autofocus: { type: Boolean, default: false }
})
const emit = defineEmits(['update:modelValue'])
const input = ref(null)

async function focus() {
  await nextTick()
  input.value?.focus()
}

onMounted(() => { if (props.autofocus) focus() })
defineExpose({ focus })
</script>

<template>
  <div class="relative">
    <svg class="pointer-events-none absolute left-3.5 top-1/2 h-5 w-5 -translate-y-1/2 text-app-muted" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round"><path d="m21 21-4.3-4.3"/><circle cx="11" cy="11" r="7"/></svg>
    <input
      ref="input"
      :value="modelValue"
      type="search"
      :placeholder="placeholder"
      class="input-field !pl-11 !pr-11"
      @input="emit('update:modelValue', $event.target.value)"
    />
    <button v-if="modelValue" type="button" class="absolute right-2 top-1/2 flex h-8 w-8 -translate-y-1/2 items-center justify-center rounded-lg text-app-muted hover:bg-slate-100" aria-label="Очистить поиск" @click="emit('update:modelValue', '')">×</button>
  </div>
</template>
